import styled, { TColorsName } from 'styled-components'

const Wrapper = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
  top: 10px;
`

const Container = styled.ul`
  position: relative;
  width: 100%;
  color: ${p => p.theme.colors.dark};
  margin-bottom: 50px;
`

const Title = styled.title`
  position: absolute;
  height: 50px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 15px;
  z-index: 50;
  font-size: 0.7rem;
  font-weight: 700;
`

const Track = styled.div`
  position: relative;
  height: 100%;
  width: 45px;
  display: flex;
  justify-content: center;
  padding-top: 10px;
`

const TrackDot = styled.span`
  position: absolute;
  height: 9px;
  width: 9px;
  background: ${p => p.theme.colors[p.color as TColorsName] || p.color};
  border-radius: 50%;
  z-index: 99;
`

const TrackLine = styled.div`
  height: 100%;
  width: 1px;
  background: ${p => p.theme.colors[p.color as TColorsName] || p.color};
  z-index: 98;
  opacity: 0.4;
`

const Content = styled.li`
  position: relative;
  height: 130px;
  width: 100%;
  top: 15px;
`

export { Wrapper, Container, Title, Track, Content, TrackDot, TrackLine }
